export default __webpack_public_path__ + "static/green-spa-logo.img-e55d01a9a06e23fe687bfb9c5f0f8730.svg";